var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDeviceMobilePlusMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 0C5.34315 0 4 1.34315 4 3V17C4 18.6569 5.34315 20 7 20H10.101C9.51513 19.4259 9.02973 18.7496 8.67363 18H7C6.44772 18 6 17.5523 6 17V3C6 2.44772 6.44772 2 7 2H7.5C7.5 2.55228 7.94772 3 8.5 3H11.5C12.0523 3 12.5 2.55228 12.5 2H13C13.5523 2 14 2.44772 14 3V8.07089C14.3266 8.02417 14.6605 8 15 8C15.3395 8 15.6734 8.02417 16 8.07089V3C16 1.34315 14.6569 0 13 0H11.5H8.5H7ZM16 11C16 10.4477 15.5523 10 15 10C14.4477 10 14 10.4477 14 11V14H11C10.4477 14 10 14.4477 10 15C10 15.5523 10.4477 16 11 16H14V19C14 19.5523 14.4477 20 15 20C15.5523 20 16 19.5523 16 19V16H19C19.5523 16 20 15.5523 20 15C20 14.4477 19.5523 14 19 14H16V11Z",
    fill: "#647FB4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeviceMobilePlusMenu);
export default __webpack_public_path__ + "static/media/icon-device-mobile-plus-menu.def031e8ff88d7992f34c00bc1f6a43d.svg";
export { ForwardRef as ReactComponent };